import { PlaybackSettings, PlaybackSpeedType } from "app/player/consts"
import { getPlayerThickIcon } from "app/player/getPlayerThickIcon"
import { currentOpenPopoverAtom } from "app/player/state"
import { Value } from "@stringtale/react"
import { useAtom } from "jotai"
import { ComponentProps, Dispatch, SetStateAction } from "react"
import PlayerIcon from "./PlayerIcon"
import PlayerOptionModal from "./PlayerOptionModal"
import PlayerDropdownOptions from "./PlayerDropdownOptions"

export default function PlayerSpeedDropDown({
  setOption,
  selectedOption,
  triggerColor = "blue",
  iconSize = 18,
  iconSrc,
  size,
}: {
  setOption: Dispatch<SetStateAction<PlaybackSpeedType>>
  selectedOption: PlaybackSpeedType
  triggerColor?: ComponentProps<typeof PlayerOptionModal>["triggerColor"]
  iconSize?: number
  iconSrc?: string
  size?: ComponentProps<typeof PlayerOptionModal>["triggerSize"]
}) {
  const [openMenu, setOpenMenu] = useAtom(currentOpenPopoverAtom)
  const isNonDefaultSpeed = selectedOption !== "NORMAL"
  const resolvedIconSrc =
    iconSrc ?? getPlayerThickIcon(triggerColor ?? "blue", "ico_speed.svg")

  return (
    <PlayerOptionModal
      title={
        <Value name="apps.web.src.video-slides.components.player.playerspeeddropdown.afspeelsnelheid">
          Afspeelsnelheid
        </Value>
      }
      icon={<PlayerIcon src={resolvedIconSrc} size={iconSize} />}
      activeIcon={
        <PlayerIcon
          src="/icons/player/thick/ico_speed_active.svg"
          size={iconSize}
        />
      }
      triggerColor={triggerColor}
      triggerSize={size}
      triggerToggled={isNonDefaultSpeed}
      open={openMenu === "speed"}
      onOpenChange={(val) => {
        setOpenMenu((prev) => (prev === "speed" && !val ? null : "speed"))
      }}
    >
      <PlayerDropdownOptions
        data={PlaybackSettings}
        options={PlaybackSettings}
        setOption={setOption}
        selectedOption={selectedOption}
        onOptionSelect={() => setOpenMenu(null)}
      />
    </PlayerOptionModal>
  )
}
